export const UserAuthentication = {
    REQUEST_IS_LOGGED_IN: 'REQUEST_IS_LOGGED_IN',
    RECEIVE_IS_LOGGED_IN: 'RECEIVE_IS_LOGGED_IN',
};
